
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores/[cName]/brands",
      function () {
        return require("private-next-pages/stores/[cName]/brands/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/stores/[cName]/brands"])
      });
    }
  